import {useQuoteContext} from "../../../contexts/QuoteContext";
import React, {useContext} from "react";
import {ConfiguratorContext} from "../../../context";
import Utils from "../../../util/util";
import {ApprovalAction} from "../../../api/models";
import {Alert} from "antd";

const AlertRejected = () => {
    const {quote} = useQuoteContext();

    const configurator = useContext(ConfiguratorContext);
    const quoteState = Utils.getQuoteState(configurator, quote);
    const {
        isOrder,
        isPending,
    } = quoteState;

    if ( !quote?.latestApproval  ) return <></>;

    const showRejected = (quote?.latestApproval?.action === ApprovalAction.REJECTED && quote.latestApproval.quoteInfo.quoteRevisionId === quote.displayRevisionId && !isPending);
    if ( !showRejected ) return <></>;

    return <Alert type="error" message={<>
        <div>{isOrder ? "These changes have" : "This quote has"} been rejected by {!!quote.latestApproval.actionedBy &&
          <span>{quote.latestApproval.actionedBy.name}</span>}.
        </div>
        {!!quote.latestApproval.actionNotes?.length &&
          <div style={{padding: ".4rem"}}>Details: {quote.latestApproval.actionNotes}</div>}
        <div>For more information contact your sales engineer or sales desk.</div>
    </>}
    />

}

export default AlertRejected;
